window._GlobalAddToCart = function(variantId, data, self) {
  fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    quantity: 1,
    id: variantId
  })
})
  .then(function(res) { return res.json(); })
  .then(function(product) {
      var resourceUrl = document.querySelector('.fs-buy-now-form').dataset.sourceUrl;
      self.track("AddToCart_ItemAdded",
        product.url,
        resourceUrl,
        product.price,
        undefined,
        { "fs_product_url": product.url, "fs_resource_url": resourceUrl, "fs_product_price": product.price }
      );
      window.refreshThemeCart();
      self.hideBuyForm();
      self.closeDetail();
  })
  .catch(function(err) { console.error('[Foursixty] AddToCart failed', err); });
}
